import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    minHeight: theme.spacing(6),
    transition: theme.transitions.create(),

    '&:hover': {
      backgroundColor: theme.palette.custom.surface[1],
    },

    '& .list-channels-item': {
      '&-link': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        color: theme.palette.text.primary,
      },
      '&-text': {
        flexGrow: 1,
        color: 'inherit',
      },
      '&-icon': {
        minWidth: theme.spacing(4),
        margin: theme.spacing(0, 2, 0, 1),
        color: 'inherit',
        '&-after': {
          margin: theme.spacing(0, 0, 0, 2),
          color: theme.palette.text.icon,
        },
      },
    },
  },

  linkTextRoot: {},

  listItemSelected: {
    '&, &:hover': {
      backgroundColor: [fade(theme.palette.primary.main, 0.12), '!important'],
      '& .list-channels-item': {
        '&-link': {
          color: [theme.palette.primary.main, '!important'],
        },
      },
    },
  },
}));

export default styles;
